<template>
  <div>
    <v-app-bar app color="blue-grey darken-3" dark clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>LeanCMS</v-toolbar-title>
      <v-spacer />
      <v-select
        outlined
        hide-details
        single-line
        dense
        style="max-width: 10rem"
        label="Language"
        v-model="selectedLanguage"
        :items="languages"
        class="mr-2"
      />
      <v-select
        outlined
        hide-details
        single-line
        dense
        style="max-width: 10rem"
        label="Workspace"
        v-model="workspace"
        :items="workspaces"
      />
      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :link="true">
            <v-list-item-title @click="logout">Logout</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/users">
            <v-list-item-title>Administration</v-list-item-title>
          </v-list-item>
          <v-list-item to="/account/change-password">
            <v-list-item-title>Change Password</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <lean-navigation-drawer :drawer="drawer" />
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import LeanNavigationDrawer from '@/components/navigation/LeanNavigationDrawer';
export default {
  name: 'lean-navigation',
  components: {
    LeanNavigationDrawer
  },
  data() {
    return {
      drawer: true,
      workspaces: ['unpublished', 'published'] // TODO: load this from systemConfig
    };
  },
  computed: {
    ...mapState({
      languages: (state) => state.languages
    }),
    selectedLanguage: {
      get() {
        return this.$store.state.selectedLanguage;
      },
      set(value) {
        this.$root.$i18n.locale = value.split('_').shift().toLowerCase();
        this.setSelectedLanguage(value);
      }
    },
    workspace: {
      get() {
        return this.$store.state.workspace;
      },
      set(value) {
        this.setWorkspace(value);
      }
    },
    search: {
      get() {
        return this.$store.state.search;
      },
      set(value) {
        this.setSearch(value);
      }
    },
    isModelDataList() {
      return !!this.$store.state.models[this.$route.params.datatype] && !this.$route.params.slug;
    }
  },
  methods: {
    ...mapActions('cognito', ['signOut']),
    ...mapMutations({
      setSearch: 'setSearch',
      setSelectedLanguage: 'setSelectedLanguage',
      setWorkspace: 'setWorkspace',
      setSessionLoaded: 'setIsSessionLoaded'
    }),
    async logout() {
      this.signOut().finally(() => {
        this.isLoading = false;
        this.setSessionLoaded = false;
      });
    }
  }
};
</script>
